import LegalLayout from "../components/LegalLayout";

const H = ({ children }) => (
  <h2 className="font-serif text-2xl md:text-3xl text-ciruela mt-10 mb-2">{children}</h2>
);

export default function PoliticaCookies() {
  return (
    <LegalLayout title="Política de cookies" updated="Junio 2026">
      <p>
        Esta política de cookies explica qué son las cookies, cómo las utiliza el sitio web de Lorena
        Cotano y qué opciones tienes para gestionarlas.
      </p>

      <H>1. ¿Qué son las cookies?</H>
      <p>
        Las cookies son pequeños archivos de texto que los sitios web almacenan en tu dispositivo cuando
        los visitas. Sirven para que la web funcione correctamente, recordar tus preferencias y, en
        algunos casos, obtener información estadística sobre la navegación.
      </p>

      <H>2. Tipos de cookies que utilizamos</H>
      <p>
        <strong>Cookies técnicas o necesarias:</strong> imprescindibles para el correcto funcionamiento
        del sitio y para recordar tus preferencias de consentimiento de cookies.
      </p>
      <p>
        <strong>Cookies analíticas y de terceros:</strong> nos permiten conocer de forma anónima cómo
        interactúan los usuarios con el sitio web para mejorar su contenido. Estas cookies solo se activan
        si das tu consentimiento.
      </p>

      <H>3. Gestión y consentimiento</H>
      <p>
        Al acceder por primera vez al Sitio Web se muestra un aviso que te permite aceptar o rechazar el
        uso de cookies no necesarias. Puedes cambiar tu decisión en cualquier momento borrando las cookies
        almacenadas en tu navegador.
      </p>

      <H>4. Cómo desactivar las cookies en tu navegador</H>
      <p>
        Puedes permitir, bloquear o eliminar las cookies instaladas a través de la configuración de tu
        navegador. A continuación, enlaces de ayuda de los navegadores más habituales: Google Chrome,
        Mozilla Firefox, Safari y Microsoft Edge. Ten en cuenta que desactivar ciertas cookies puede
        afectar al funcionamiento del Sitio Web.
      </p>

      <H>5. Actualización de la política</H>
      <p>
        Esta política de cookies puede actualizarse en función de cambios normativos o técnicos. Te
        recomendamos revisarla periódicamente.
      </p>
    </LegalLayout>
  );
}
